import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Firstpg from './components/Firstpg';
import About from './components/Aboutus';
import ContactForm from './components/Contact';
import Services from './components/Service';
import Security from './components/Security';
import TeamBackgroundWithContent from './components/Ourteampg';
import Page from './components/Catagoryindex';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import EmployeeLogin from './employee/EmployeeLogin';
import EmployeeDashboard from './employee/EmployeeDashboard';
import EnrollMFA from './admin/EnrollMFA';
import 'bootstrap/dist/css/bootstrap.min.css';


import './index.css'; 
const ProtectedRoute = ({ children, allowedRole }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="text-center mt-5">Loading...</div>;
  if (!user) return <Navigate to="/employee-login" />;
  if (user.role !== allowedRole) return <Navigate to="/employee-login" />;
  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Navbar />
        <Routes>
          {/* Public static routes */}
          <Route path="/" element={<Firstpg />} />
          <Route path="/firstpg" element={<Firstpg />} />
          <Route path="/aboutus" element={<About />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/services" element={<Services />} />
          <Route path="/security" element={<Security />} />
          <Route path="/ourteampg" element={<TeamBackgroundWithContent />} />
          <Route path="/catagoryindex" element={<Page />} />
          {/* Authenticated routes */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute allowedRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/employee-login" element={<EmployeeLogin />} />
          <Route
            path="/employee-dashboard"
            element={
              <ProtectedRoute allowedRole="employee">
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enroll-mfa"
            element={
              <ProtectedRoute allowedRole="admin">
                <EnrollMFA />
              </ProtectedRoute>
            }
          />
          {/* Redirect unknown routes to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;